








import { Component, Ref, Vue } from "vue-property-decorator";
import TariffZoneGroup from "../Tarification/TariffZoneGroup.vue";
import { TarificationTransports, TarificationTypes } from "@/store/tarification/types";

// Component.registerHooks(["beforeRouteLeave"]); // Почему-то без этого работает...

@Component({ components: { TariffZoneGroup } })
export default class SmsPartnerTariffZoneGroup extends Vue {
  @Ref("tariffZoneGroup") private tariffZoneGroup!: TariffZoneGroup;

  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.SMS;

  beforeRouteLeave(to: any, from: any, next: any): void {
    this.tariffZoneGroup.beforeLeave(to, from, next);
  }
}
